import VerticalPage from "@/components/VerticalPage";
import { Coins } from "@phosphor-icons/react";

export default function PreciousMetals() {
  return (
    <VerticalPage
      eyebrow="Portfolio · Precious Metals"
      title="Precious Metals"
      subtitle="Gold, silver, and other physical holdings — stored or allocated."
      IconLg={Coins}
      assetType="precious_metals"
    />
  );
}
